import { CartItemModel } from "../../models";
import { CartProduct } from "..";

type Props = {
  cartItems: CartItemModel[];
  editable?: boolean | undefined;
};

const CartProductList: React.FC<Props> = ({ cartItems, editable }) => {
  return (
    // <div className={clsx("your_order_box", !editable && "editable-cart")}>
    <div className="your_order_box">
      <ul>
        {cartItems.map((cartItem, index) => (
          <CartProduct
            key={index}
            index={index}
            cartItem={cartItem}
            editable={editable}
          />
        ))}
      </ul>
    </div>
  );
};

export default CartProductList;
